import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import { LoadingButton } from '@mui/lab';
import { Tooltip } from '@mui/material';
import { IcomxResourceDescriptor } from 'src/services/api/icomx';
import { useIcomxChat } from './IcomxChatContext';

interface IcomxResourceLauncherProps extends IcomxResourceDescriptor {}

export default function IcomxResourceLauncher({ resourceType, resourceId }: IcomxResourceLauncherProps) {
  const { isEnabled, isLoading, isLaunching, openResourceConversation } = useIcomxChat();

  if (isLoading || !isEnabled) {
    return null;
  }

  return (
    <Tooltip title="Open iComx">
      <span>
        <LoadingButton
          loading={isLaunching}
          variant="contained"
          startIcon={<ChatBubbleOutlineIcon />}
          onClick={() => openResourceConversation({ resourceType, resourceId })}
        >
          iComx
        </LoadingButton>
      </span>
    </Tooltip>
  );
}